import React from 'react';
import { Link } from 'react-router-dom';
import Nav from '../components/Nav';
import Footer from '../components/Footer';
import useSEO from '../common/useSEO';

export default function NotFound() {
  useSEO({
    title: '404 NOT FOUND — Aaron Figueroa',
    description: 'The requested page could not be found.',
    path: '/404'
  });

  return (
    <div className="min-h-screen bg-[#000000] text-[#FFFFFF] font-sans selection:bg-[#FFFFFF] selection:text-[#000000]">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 lg:px-8 flex flex-col min-h-screen">
        <Nav />

        <main className="w-full flex-grow flex flex-col items-center justify-center text-center py-[10vh]">
          <h1 
            className="font-bold text-[#FFFFFF]"
            style={{ fontSize: 'clamp(4rem, 8vw, 7rem)', letterSpacing: '0.05em', lineHeight: 1 }}
          >
            404
          </h1>
          <h2 
            className="uppercase text-[#888888]"
            style={{ fontSize: '1rem', letterSpacing: '0.15em', marginBottom: '2rem', marginTop: '1rem' }}
          >
            PAGE NOT FOUND
          </h2>
          <Link 
            to="/"
            className="bg-[#FFFFFF] text-[#000000] px-8 py-4 text-[0.85rem] font-bold tracking-[0.1em] uppercase hover:bg-[#e0e0e0] transition-colors"
          >
            RETURN HOME
          </Link>
        </main>

        <div className="mt-auto">
          <Footer />
        </div>
      </div>
    </div>
  );
}